module.exports = __webpack_public_path__ + "static/9-10fdf4877697c8dcbe6511da65e4378e.jpg";